<template>
  <div >
    <a-back-top />
    <a-row>
      <a-col :md="24">
        <div class="allbody" :style="{transform : `scale(${scaleW},${scaleH})`}">
<!--          <div style="float: left;margin-top: 1%;margin-left: 10%">
            <img src="~@/assets/imgs/logo1.png" width="40">
          </div>-->
          <div style="margin-top: 1%;float: right;margin-right: 15%;">
            <router-link to='/'><a>首页</a></router-link>
            <router-link to='/productintr'><a>产品介绍</a></router-link>
            <router-link to='/aboutus'><a>关于我们</a></router-link>
            <router-link to='/caseinfo'><a>业绩案例</a></router-link>
            <router-link to='/contantus'><a-button shape="round" style="background-color: #3B43F2;color: white">联系我们</a-button></router-link>
          </div>
          <div class="contant"></div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;margin-top: 2%;margin-bottom: 3%;color: #101010;">
          <p style="font-size: 20px;">联系我们</p>
          <p style="font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23% 2% 23%">
            <span> 南京汇钧云合科技有限公司成立于2025年11月21日，经营范围包括一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；信息咨询服务（不含许可类信息咨询服务）；信息技术咨询服务；广告设计、代理；广告制作；计算机软硬件及辅助设备零售；信息系统集成服务；人工智能硬件销售；电子产品销售；人工智能应用软件开发；数字视频监控系统销售；安全系统监控服务；互联网数据服务；数据处理和存储支持服务；科技推广和应用服务；物联网技术研发；物联网设备销售；物联网技术服务；信息系统运行维护服务；网络与信息安全软件开发；安全技术防范系统设计施工服务；人工智能行业应用系统集成服务；人工智能公共数据平台；人工智能通用应用系统；人工智能基础资源与技术平台；人工智能理论与算法软件开发（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）</span>
          </p>
          <div style="text-align: left;width: 30%;margin: 0 auto">
            <div style="font-size: 12px">地址：江苏省南京市建邺区奥体大街69号3栋106号</div>
            <div style="font-size: 12px">电话：025-8663 0767</div>
            <div style="font-size: 12px">邮箱：public@jsnanrui.com</div>
          </div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="height: 350px;" id="divmap"> </div>
      </a-col>
      <a-col :md="24">
        <foot-boot1 />
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import footBoot1 from './footboot1'
  import AMapLoader from '@amap/amap-jsapi-loader';
  export default {
    name: 'Website',
    components: {
      footBoot1
    },
    data () {
      return {
        scaleW: 1,
        scaleH: 1,
        size:50,
        tabBarGutter:100
      }
    },
    created(){
      this.setmap()
    },
    methods: {
      setmap(){
        window._AMapSecurityConfig = {
          securityJsCode: 'ee9e9f3f787e1686370aa30fa256096f',
        };
        setTimeout(()=>{
          AMapLoader.load({
            key: 'f5d476d54836ac3a912a64d9f458d9dd', // 申请好的Web端开发者Key，首次调用 load 时必填
            version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            resizeEnable: true, // 定位到当前位置
            plugins: [
              'AMap.ToolBar', //工具条
              'AMap.Scale',
              'AMap.Geocoder',
              'AMap.getCenter',
              'AMap.InfoWindow',
            ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          })
            .then((AMap) => {
              let map = new AMap.Map('divmap', {
                //   viewMode: '3D', //是否为3D地图模式
                zoom: 8, //初始化地图级别 // 3-18
                center: [118.74144,31.99654], //地图中心点
              });
              map.addControl(new AMap.Scale()); // 比例尺
              const position = new AMap.LngLat(118.74144,31.99654); //Marker 经纬度
              var icon = new AMap.Icon({
                size: new AMap.Size(20, 30), // 图标的大小
                image: require('./../assets/image/markerbig3.png'), // 自定义图标的 URL
                imageSize: new AMap.Size(20, 30), // 图标的显示大小
                anchor: new AMap.Pixel(1, 0), // 设置锚点为中心点
              });
              var marker = new AMap.Marker({
                position: position,
                offset: new AMap.Pixel(-10, -15), //相对于基点的偏移位置
                icon: icon,
              });
              marker.on('click', (e) => {
                // this.setInfoWindows(e, item, dataList[i][index]);
                let content = [
                  // e.pos[0],e.pos[1],
                  `<div style='font-size:14px;cursor: pointer;color:#333'><b>南京市建邺区新城科技园国际研发总部园3栋11楼</b></div>`,
                ];
                // 创建 infoWindow 实例
                let infoWindow = new AMap.InfoWindow({
                  content: content.join('</div>'), //传入 dom 对象，或者 html 字符串
                });
                infoWindow.open(map, map.getCenter());
              });
              map.add(marker);
              map.setFitView(marker);
            })
            .catch((e) => {
              console.log(e);
            });
        },1000)
      },
    }
  }
</script>
<style>
  .anchorBL {
    display: none;
  }
  .BMap_cpyCtrl .BMap_noprint .anchorBL {
    display: none;
  }
</style>
<style scoped>
  a{
    white-space: nowrap;
    color: black;
    font-family: SourceHanSansSC-regular;
    margin-right: 5%;
  }
  a:hover{
    color: black;
    font-weight: bold;
  }
  .allbody{
    width: 100%;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
  }
  .allbody img{
    width: 140px;
    height: 30px;
  }
  .contant{
    height: 350px;
    margin-top: 4%;
    text-align: center;
    padding-top: 6%;
    background: url('~@/assets/imgs/contanrus.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contantus.vue